// removed by extract-text-webpack-plugin
module.exports = {"root":"_2a6Mg","skill":"_1jdr8","skillIcon":"_38a3o","skillName":"Kzt5S"};


//////////////////
// WEBPACK FOOTER
// ../source/components/UserSkills/styles.css
// module id = 1483
// module chunks = 6 9